module.exports = __webpack_public_path__ + "static/media/04.d6a6d390.png";